import { Pipe, PipeTransform, inject } from '@angular/core';
import { ShortNumberService } from './short-number.service';

@Pipe({
  name: 'shortNumber',
  standalone: true,
})
export class ShortNumberPipe implements PipeTransform {
  private readonly shortNumberService = inject(ShortNumberService);

  public transform(value: number | null | undefined, fixed = 0, isCurrency = false): string {
    return this.shortNumberService.abbrieviate(value, fixed, isCurrency);
  }
}
